// @todo delete these polyfills once the hermes javascript engine supports them
import 'core-js/proposals/iterator-helpers-stage-3-2'
import 'core-js/proposals/array-from-async'
import 'core-js/proposals/array-grouping-v2'
import 'core-js/proposals/change-array-by-copy-stage-4'
import 'core-js/proposals/promise-with-resolvers'
import 'core-js/proposals/promise-try'

import '@expo/match-media'
import '@/src/services/Braze'

import 'react-native-gesture-handler'
import 'react-native-reanimated'

// Please do not delete, we have libs that relies on this to function
import 'react-native-get-random-values'
